import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const TopBar = ({ children, showBack = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang, toggleLanguage } = useLanguage();
  
  const isLine20 = location.pathname.includes('line20');
  const isLine10 = location.pathname.includes('line10');

  return (
    <div className="sticky top-0 z-50 bg-slate-900/90 backdrop-blur-md border-b border-slate-800 px-4 py-3 flex items-center shadow-sm">
      {showBack && (
        <button 
          onClick={() => navigate('/')}
          className="mr-2 p-2 -ml-2 rounded-full hover:bg-slate-800 active:bg-slate-700 transition-colors shrink-0"
          aria-label="Back to home"
        >
          <SafeIcon icon={FiIcons.FiArrowLeft} className="text-xl text-slate-300" />
        </button>
      )}
      
      <div className="flex-1 truncate flex items-center space-x-3">
        <img 
          src="https://media-manager-c.questera.ai/greta-media/50a89aa21e8592ba83277bab02d4620fffd593174204cd4ebb527c1b0cf7a3b3c85745aca5771fccfd9d4e09ed07fe1e/images/aW1hZ2UvcG5n/e033d5a1f899e8970cdbda0d75ff772c.png" 
          alt="Alimos Telematics Logo" 
          className="w-10 h-10 rounded-full shadow-sm object-cover bg-black shrink-0 border border-slate-700"
        />
        <div className="flex flex-col min-w-0">
          <span className="text-sm font-bold text-white truncate leading-tight">
            Alimos Telematics
          </span>
          {children}
        </div>
      </div>

      <div className="flex items-center ml-2 shrink-0">
        {isLine20 && (
          <Link 
            to="/timetable/line10" 
            className="flex items-center space-x-1 px-3 py-1.5 rounded-full bg-blue-900/40 text-blue-300 hover:bg-blue-900/60 transition-all border border-blue-800/50 mr-2 active:scale-95 shadow-sm"
          >
            <span className="text-[10px] font-bold uppercase tracking-tight">Line 10</span>
            <SafeIcon icon={FiIcons.FiArrowRight} className="text-xs" />
          </Link>
        )}
        
        {isLine10 && (
          <Link 
            to="/timetable/line20" 
            className="flex items-center space-x-1 px-3 py-1.5 rounded-full bg-emerald-900/40 text-emerald-300 hover:bg-emerald-900/60 transition-all border border-emerald-800/50 mr-2 active:scale-95 shadow-sm"
          >
            <span className="text-[10px] font-bold uppercase tracking-tight">Line 20</span>
            <SafeIcon icon={FiIcons.FiArrowRight} className="text-xs" />
          </Link>
        )}

        <button 
          onClick={toggleLanguage}
          className="flex items-center space-x-1 px-3 py-1.5 rounded-full bg-slate-800 hover:bg-slate-700 transition-colors border border-slate-700"
        >
          <span className={`text-[10px] font-bold ${lang === 'el' ? 'text-white' : 'text-slate-500'}`}>ΕΛ</span>
          <div className="w-px h-3 bg-slate-600 mx-0.5" />
          <span className={`text-[10px] font-bold ${lang === 'en' ? 'text-white' : 'text-slate-500'}`}>EN</span>
        </button>
      </div>
    </div>
  );
};

export default TopBar;